'use client';

import React, { ReactNode } from 'react';

import Link, { LinkProps } from 'next/link';

import cn from '@/helpers/utils/classNames';

export type PseudoLinkProps = Omit<LinkProps, 'href'> & {
  className?: string;
  children: ReactNode;
};

const PseudoLink: React.FC<PseudoLinkProps> = ({ onClick, className, children, ...restProps }) => {
  return (
    <Link
      href="#"
      className={cn(className)}
      onClick={event => {
        event.preventDefault();
        onClick && onClick(event);
      }}
      {...restProps}
    >
      {children}
    </Link>
  );
};

export default PseudoLink;
